import React from 'react';
import RegulatoryDashboard from './RegulatoryDashboard';

const DashboardRegulatory = () => {
  return (
    <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900">Telecom Regulatory Dashboard</h1>
        <p className="text-gray-600 mt-2">Monitor regulatory compliance and service quality across all telecom operators</p>
      </div>

      {/* Regulatory Dashboard - Main component */}
      <div className="mb-8">
        <RegulatoryDashboard />
      </div>
    </main>
  );
};

export default DashboardRegulatory;